module.exports = __webpack_public_path__ + "img/tool_tip_dark.af5248d.svg";